/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import Person from "@material-ui/icons/Person";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import CustomeSelect from "../CustomeSelect";
import DropDown from "./DropDown";
import ToastModal from "views/components/ToastModal";

import { parseAndSetFlag } from "utils/Utils";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import Notification from "./Notification";

const useStyles = makeStyles(() => ({
  headerContainer: {
    display: "flex",
    alignItems: "center",
    height: "76px",
    padding: "0 20px",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    gap: "15px",
  },

  headerItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "110px",
  },

  iconRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    height: "26px",
  },

  itemIcon: {
    fontSize: "22px",
  },

  arrowIcon: {
    fontSize: "18px",
    marginTop: "2px",
  },

  itemText: {
    fontSize: "12px",
    textAlign: "center",
    fontWeight: 400,
    color: "#333",
    marginTop: "0px",
    lineHeight: "14px",
  },
}));

const DesktopHeader = ({
  userDetailsData,
  listData,
  handelChange,
  seletedBranchName,
  outletData,
  setNotifications, 
  notifications
}) => {
  const classes = useStyles();

  const [openProfile, setOpenProfile] = useState(null);
  const [moduleData, setModuleData] = useState({});
  const { authToken } = useSelector((state) => state.login.authData);
  const { email } = useSelector((state) => state.login.userData);
  const [username, setUserName] = React.useState(userDetailsData?.name);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const enableMultiBranch =
    parseAndSetFlag(outletData?.enableMultiBranchFlow) ||
    (outletData?.enabledMultiBranchAsPerUser || []).includes(
      userDetailsData?.designation
    );

  const navigateToLoginPage = async () => {
    const result = await apiHandler({
      url: endpoint.APP_URL,
      authToken: authToken,
    });
    if (result?.data?.main) window.location.href = result.data.main;
  };

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const openModule = async (module) => {
    const result = await apiHandler({
      url: endpoint.RETAIN_TOKEN,
      method: "POST",
      authToken: authToken,
      data: {
        username: email,
        accessToken: authToken,
      },
    });

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      window.open(
        moduleData[module] + "/auto/" + result?.data?.uuid,
        "_self"
      );
    }
  };

  const getOtherAppsUrl = async () => {
    const result = await apiHandler({ url: endpoint.APP_URL });
    setModuleData(result.data);
  };

  const handleClickProfile = (e) => {
    if (openProfile && openProfile.contains(e.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(e.currentTarget);
    }
  };

  const handleCloseProfile = () => setOpenProfile(null);

  useEffect(() => {
    if (authToken) getOtherAppsUrl();

    function storageChange(event) {
      if (event.key === "persist:root") {
        const { login } = JSON.parse(event.newValue);
        const { authData } = JSON.parse(login);
        if (authData && !authData.isAuthenticated) navigateToLoginPage();
      }
    }

    window.addEventListener("storage", storageChange);
    return () => window.removeEventListener("storage", storageChange);
  }, [authToken]);

  const formatDate = () => {
    const d = new Date();
    const day = ("0" + d.getDate()).slice(-2);
    const year = d.getFullYear();
    const month = d.toLocaleString("default", { month: "long" });
    return `${day}-${month}-${year}`;
  };
  const unreadNotification = notifications?.filter((item)=> !item?.read)
  return (
    <Grid container className={classes.headerContainer}>
      {/* LEFT SIDE — BRANCH SELECT */}
      <Grid item xs={12} sm={12} md={3} lg={3}>
        {enableMultiBranch && (
          <CustomeSelect
            label="Branch Name*"
            id="branch_name"
            value={seletedBranchName}
            setState={handelChange}
            data={listData}
            type="branch"
          />
        )}
      </Grid>

      {/* RIGHT SIDE — DATE | BRANCH | PROFILE */}
      <Grid item xs={12} sm={12} md={9} lg={9} className={classes.rightSection}>
        <div className={classes.headerItem} style={{display:'flex', maxWidth:'max-content', flexDirection:'row',backgroundColor:'#e8f0fe', gap:'5px', padding:'10px', borderRadius:'50px'}}>
            <Notification
              setNotifications={setNotifications}
              notifications={notifications}
              username={username}
            />
            <span className={classes.itemText} style={{color:'#000000', fontWeight:700}}>{unreadNotification?.length > 0 ? "Unread Notifications" : "Notifications"}</span>
          </div>
        {/* DATE */}
        <div className={classes.headerItem}>
          <div className={classes.iconRow}>
            <CalendarTodayIcon className={classes.itemIcon} />
          </div>
          <span className={classes.itemText}>{formatDate()}</span>
        </div>

        {/* BRANCH */}
        <div className={classes.headerItem}>
          <div className={classes.iconRow}>
            <AccountBalanceIcon className={classes.itemIcon} />
          </div>
          <span className={classes.itemText}>
            {userDetailsData?.branchName}
          </span>
        </div>

        {/* PROFILE */}
        <div className={classes.headerItem} onClick={handleClickProfile}>
          <div className={classes.iconRow}>
            <Person className={classes.itemIcon} />
            {openProfile ? (
              <KeyboardArrowUpIcon className={classes.arrowIcon} />
            ) : (
              <KeyboardArrowDownIcon className={classes.arrowIcon} />
            )}
          </div>

          <span className={classes.itemText}>{userDetailsData?.name}</span>
        </div>
      </Grid>

      {/* DROPDOWN MENU */}
      <DropDown
        navigateToLoginPage={navigateToLoginPage}
        handleCloseProfile={handleCloseProfile}
        openProfile={openProfile}
        handleExitToSSO={() => openModule("main")}
      />

      {/* TOAST */}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

DesktopHeader.propTypes = {
  classes: PropTypes.object,
};

export default DesktopHeader;
